<script>
  import options from './ProductGrid.options'
  export default options
</script>

<template>
  <article class="nlx-product-grid">
    <section class="nlx-product-grid__filter-controls">
      <FilterComponentControls />
    </section>

    <section class="nlx-product-grid__filter-container" :class="displayingFilterColumn">
        <FilterComponent :tabindex="(displayingFilterColumn ? 0 : -1)" />
    </section>

    <section class="nlx-product-grid__products-container" :class="gridContainerModifier" ref="gridContainer">

      <template v-for="(product,key) in productList" :key="key">
        <ProductSpot :productData="product" :ambienceToggle="ambienceToggle" />
      </template>

      <template v-if="noProductsToShow">{{noProductsToShow}}
        <p class="nlx-product-grid__no-products-msg">{{getLabel('noProductsToShow')}}</p>
      </template>

      <template v-if="spinnerVisible">
        <div class="nlx-loading-spinner-overlay">
          <div class="nlx-loading-spinner"></div>
        </div>
      </template>

    </section>

    <template v-if="moreResultsAvailable">
      <div class="nlx-product-grid__load-more-container">
        <button @click="loadMoreResults" class="nlx-button">{{getLabel('load_more')}}<strong>({{takeValue}})</strong></button>
      </div>
    </template>

  </article>
</template>
